import TableHead from "./table-head";
import AmpleHireTableLoader from "../../loaders/ample-hire-table-loader";

const TableBody = ({
  children,
  tableHeadValues,
  showFilter = false,
  filterArray,
  setFilterArray,
  tableName,
  getFilteredRows,
  loading,
  customSortArray = [],
}) => {
  return (
    <div className="table-bodywr table-responsive">
      {loading ? (
        <AmpleHireTableLoader />
      ) : (
        <table className="striped responsive-table topalign-table">
          <TableHead
            tableHeadValues={tableHeadValues}
            showFilter={showFilter}
            filterArray={filterArray}
            setFilterArray={setFilterArray}
            tableName={tableName}
            getFilteredRows={getFilteredRows}
            customSortArray={customSortArray}
          />
          <tbody>{children}</tbody>
        </table>
      )}
    </div>
  );
};

export default TableBody;
